export enum StatusEnum {
    APPROVED = 'approved',
    AUTHORIZED = 'authorized',
    IN_PROCESS = 'in_process',
    PENDING = 'pending'
}